import React, { useState } from 'react';

export default function ThinkyIOTTaaP({ onBack }) {
  const [modules] = useState([
    { id: 1, name: 'Predictive Maintenance', description: 'AI-driven maintenance alerts for machinery to prevent downtime.' },
    { id: 2, name: 'Energy Optimization', description: 'Monitor and optimize energy consumption across plants.' },
    { id: 3, name: 'Quality Control Automation', description: 'Real-time defect detection and process optimization using IoT sensors.' },
    { id: 4, name: 'Supply Chain Analytics', description: 'Track inventory, logistics, and demand forecasts with actionable insights.' },
    { id: 5, name: 'Operational Dashboards', description: 'Composable dashboards for performance monitoring, KPIs, and operational alerts.' },
  ]);

  return (
    <div className="min-h-screen bg-black text-white px-4 py-8">
      <button onClick={onBack} className="mb-6 px-4 py-2 bg-blue-600 rounded hover:bg-blue-500 w-24">&larr; Back</button>
      <h1 className="text-lg lg:text-xl font-bold mb-6">Transformation-as-a-Platform (TaaP)</h1>

      <p className="mb-6 text-blue-300 text-center text-sm">Composable IoT + AI + workflow modules designed for continuous operational transformation, focused on MSME & IIoT use cases.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {modules.map(module => (
          <div key={module.id} className="bg-neutral-900 border border-neutral-800 rounded-2xl p-5 shadow-sm">
            <h3 className="text-lg font-semibold mb-2">{module.name}</h3>
            <p className="text-sm text-neutral-300 leading-relaxed">{module.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
